import Backbone from 'backbone';

export default Backbone.View.extend({
    events: {
        'change #transfer-portal-customer': 'onPortalCustomerChange',
        'change #transfer-orderer': 'onOrdererChange',
        'click #submitTransfer': 'onTransferClick'
    },

    initialize: function () {
        this.onPortalCustomerChange();
    },

    onPortalCustomerChange: function () {
        this.$el.find('#transfer-orderer option')
            .first()
            .prop('selected', true);
    },

    onOrdererChange: function () {
        const selectedIndex = this.$('#transfer-orderer').prop('selectedIndex');
        if (selectedIndex !== 0) {
            this.$('#submitTransfer').prop('disabled', false);
            this.$('#submitTransfer').removeClass('disabled');
        } else {
            this.$('#submitTransfer').prop('disabled', true);
            this.$('#submitTransfer').addClass('disabled');
        }
    },

    onTransferClick: function () {
        const form = this.$el.find('form');
        if (form[0].checkValidity()) {
            form[0].submit();
        }
    }
});



// WEBPACK FOOTER //
// ./views/shoppingCart/TransferModalController.js